module.exports = __webpack_public_path__ + "img/jstree-ocl.7ed8dbc.png";